"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stacks = void 0;
const __1 = require("../../");
exports.stacks = [
    {
        name: 'spooKey Badge 2021',
        description: 'Give any enemy FUD +2',
        type: __1.GameCardTypes.SPELL,
        potassium: 2,
        templateId: 339233,
        gif: true,
        gameClass: __1.GameClasses.Festive,
        spell: {
            name: 'ModifierEffect',
            params: {
                modifier: 'FUD',
                value: 2,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature],
            },
        },
    },
    {
        name: 'Welcome to the monKeyverse',
        description: 'Blocker',
        templateId: 339229,
        type: __1.GameCardTypes.CREATURE,
        potassium: 2,
        attack: 2,
        health: 3,
        modifiers: {
            Blocker: true,
        },
    },
    {
        name: 'monKeyprinter BRRrain',
        gif: true,
        description: 'High. Blocker',
        templateId: 339228,
        type: __1.GameCardTypes.CREATURE,
        potassium: 3,
        attack: 3,
        health: 3,
        modifiers: {
            Blocker: true,
            High: true,
        },
    },
];
